import * as React from 'react';
import ConnectionNotification from '@om-fe/core/components/notification/connection-notification';
import BreakpointWrapper from '@om-fe/core/components/breakpoint-wrapper/breakpoint-wrapper';
import RightSideBar from '@om-fe/core/pages/theme1/parts/right-side-bar';
import TemplateContent, { BaseTemplatePublicProps } from '@om-fe/core/core/routing/templates/template-content';
import { bemContent } from '@om-fe/core/core/routing/templates/template.utils';
import Header from '@om-fe/core/pages/theme1/parts/header';
import { TemplateProps } from '@om-fe/core/template.models';
import { LiveSearchPageComponent } from '@om-fe/core/pages/theme1/live-search-page';
import { compose } from 'redux';
import withTranslation from '@om-fe/core/core/i18n/with-translation';
import { RouteNames } from '@om-fe/core/core/routing/utils';
import FavoriteState from '@om-fe/core/components/favorite-button/favorite-state';
import FavoriteTournaments from '@om-fe/core/components/favorite-tournaments/favorite-tournaments';
import { Breakpoints } from '@om-fe/core/core/store/breakpoints';
import { LiveEventBar } from '@om-fe/core/components/live-event/sidebar/live-event-bar';

class LiveTemplateComponent extends React.PureComponent<TemplateProps> {
    render() {
        const { gettext } = this.props;

        return (
            <>
                <FavoriteState />
                <FavoriteTournaments />
                <BreakpointWrapper breakpoints={[Breakpoints.Large, Breakpoints.XL]}>
                    <span className={'SideBackground'}></span>
                    <LiveEventBar />
                </BreakpointWrapper>
                <section className={bemContent({ extra: 'PageScrollableContent' })}>
                    <ConnectionNotification/>
                    <Header
                        defaultSearchMap={LiveSearchPageComponent.defaultSearchMap}
                        hasSportNav={false}
                        searchTabsHasTournamentTab={false}
                        searchPlaceholder={gettext('Live Search')}
                        searchRouteName={RouteNames.liveSearch}
                    />
                    <TemplateContent {...this.props}/>
                </section>
                <BreakpointWrapper breakpoints={[Breakpoints.Small]} action="hide">
                    <RightSideBar/>
                </BreakpointWrapper>
            </>
        );
    }
}

const LiveTemplate = compose<React.ComponentClass<BaseTemplatePublicProps>>(
    withTranslation(),
)(LiveTemplateComponent);
export default LiveTemplate;
